import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AirportService, AuthService, CanonicalService, HotelService, HttpService, MetaService, UtilityService, XchangeratesService } from './services';
import { tap } from 'rxjs/operators';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'CheapTicket';
  isLoading: boolean = true; // Initially set to true
  // Prevent right-click context menu
  // Block right-click context menu
  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    event.preventDefault();
  }
  // Block Ctrl + U (view source) and F12 (developer tools)
  @HostListener('document:keydown', ['$event'])
  blockCtrlU(event: KeyboardEvent) {
    if (event.ctrlKey && (event.key === 'u' || event.key === 'U')) {
      event.preventDefault();
    }
  }
  constructor(private router: Router, private authService: AuthService, public http: HttpService, public util: UtilityService,
    private dataHotel: HotelService, private Xchangerates: XchangeratesService, private metaService: MetaService, private airport: AirportService,
    private CANON: CanonicalService) {
      this.metaService.updateMeta('Book Domestic & International Flight Tickets at Low Airfares', 'Looking for Cheap Airfare? Book domestic and international flights at unbeatable fares with BelairTrip. Enjoy exclusive deals and save big on your next flight booking.');
      // localStorage.setItem('airport',JSON.stringify(this.airport.aitport_static));
      // this.airport.fetchAndStoreAirports()
      // Simulate async operation
      // setTimeout(() => {
      //   this.isLoading = false; // Set to false when operation is complete
      // }, 2500);
      // this api is for aiport

    // this.http.flightgetall(`apiV2/airport`).subscribe((res) => {
      // if(res.statusCode === 200){
        // localStorage.setItem('airport',JSON.stringify(res.data));
      // }
    // }, err => {this.util.errorMessage(err)}) // this.util.errorMessage(err)
    // this.http.flightgetall(`apiV2/bookingClass`).subscribe((res)=> {
    //   if(res.statusCode ===200){
    //     localStorage.setItem('booking_class',JSON.stringify(res.data));
    //   }
    // }, err => {this.util.errorMessage(err)}) //
    if (this.authService.loggedIn()) {
      // this.router.navigate(['u']);
      this.router.routeReuseStrategy.shouldReuseRoute = () => {
        return false;
      };
    } else { } 

    this.Xchangerates.currencyList()
    // this.dataHotel.fetchStoreCityList();

    const url = window.location.href;
    this.CANON.SETUPCANONICALLISTENER(url);

  }
}
